import { busyWhile } from "lib/@components/busy/busy-while"
import { confirmByUserInput } from "lib/@dialogs/confirm-by-user-input"
import { useUser } from "lib/user/use-user"
import { useState } from "react"
import { getAssetCount } from "routes/asset-register/controller/get-asset-count"
import { AssetRegisterRow } from "routes/asset-register/plugins/excel-import/asset-register-row"
import { removeRegisterFromRegime } from "./controller/remove-register-from-regime"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function RegimeSelectorRow({ row }) {
    const { regime } = useBoundContext()
    const { registerName, assetCount, modifiedBy } = row
    const user = useUser(modifiedBy)
    const [removing, setRemoving] = useState(false)

    return (
        <AssetRegisterRow
            row={row}
            remove={remove}
            removing={removing}
            showIcon={false}
            user={user}
            name={registerName}
            numberOfAssets={assetCount}
            removeDemand={"syncAssetRegister"}
        />
    )

    async function remove() {
        const assetCount = await getAssetCount(row.id)

        const confirm = await confirmByUserInput({
            title: `Are you sure you want to remove ${assetCount} ${"asset".pluralize(assetCount)}?`,
            confirmValue: assetCount,
            message:
                "The regime will lose all of the assets from the asset register, they can be added again at any time.",
        })
        if (confirm) {
            try {
                setRemoving(true)
                await busyWhile(() => removeRegisterFromRegime({ registerId: row.id, regimeId: regime._id }))
                successSnackbar(`Register successfully removed`)
                setRemoving(false)
            } catch (e) {
                errorSnackbar(`Failed to remove "${row.name}"`)
            }
        }
    }
}
